module.exports = __webpack_public_path__ + "static/media/mg_group_ui_assets_seguro.49de4369.svg";